import { Group } from "lucide-react";


export const ApiKey = {
   Login: "/auth/login",
   ScholarshipApplication: "/scholarshipApplicationForm",
   uploadScholarshipFiles: "/scholarshipApplicationForm/UploadFiles",
   signup: "/userDto",
   userDto: "/UserDto",
   downloadscholarshipFiles: "/scholarshipApplicationForm/downloadFiles",
   downloadsponsorscholarshipFiles: "/Scholarship/downloadFiles",
   ScholarshipApplicationsBySponsor: "/Scholarship/bySponsor",
   ApplicationStatus: "/Scholarship",
   SendMail:"/email",
   

   signup: "/student",
   SponsorLogin: "/auth/sponsor",
   InstitutionSignup: "/Insutition",
   Student: "/student",
   Scholarship: "/Scholarship",
   SponsorScholarship: "/Scholarship",
   Sponsor: "/SponsorDto",
   Country: "/Filter/countries",
   Gender: "/Filter/genders",
   State: "/Filter/states",
   Religion: "/Filter/religions",
   Class: "/Class",
   Course: "/Course",
   GroupCourse:"/Course/grouped-by-name",
   CourseByClass: "/Course",
   InsertChat: "/Chat/send",
   GetSessionId: "/Chat/start-session",
   GetSessionClosed:"Chat/close-session",
   EmailExistCheck: "/userDto/by-email",
   ChangePassword: "Auth/change-password",
   ResetPassword: "Auth/reset-password",
   DashboardCount: "DashboardCount",
uploadVideoContent:"/faculty/UploadFiles",
VideoContent :"/faculty/GetAllVideos",
DeleteVideoContent:"/faculty",
Faculty:"/faculty",
//UpdateFaculty:"/faculty",
   DOWNLOAD_COLLEGE_TEMPLATE: "/college-details/download-template",
  UPLOAD_COLLEGE_EXCEL: "/college-details/upload-excel",
  CollegeDetails: "college-details",
  LocationDetails: "/Filter/locations",
  Managements : "/Filter/management-types",
  Collegetype : "/Filter/college-types",
  College : "/Filter/college",
  Districts : "/Filter/districts",
  States : "/Filter/state",
  GetSessionClosed:"Chat/close-session",
 Year:"/Class/GetYearByClassId",
 RaiseQuery: "/Query",
  ReplyToQuery: "/Query/reply",
  GetMyTickets: "/Query/student", // append /{studentId}
  GetTicketConversation: "/Query", // append /{id}/conversation
  GetAllQueries: "/Query/all",
};
